import { start } from '../bootstrap.jsx';

start();
